import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteGovReportingConfigMutationAtom = createMutationAtomFactory(
  'settings.govReportingConfigDelete',
  ({ id }: { id: string }) => ({
    complianceGovernmentReportingConfigurationDelete: {
      __args: {
        id,
      },
    },
  }),
);
